import { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import ErrorBoundary from "@/components/common/ErrorBoundary";
import { RequireAuth } from "@/features/auth/RequireAuth";

const LoginPage = lazy(() => import("@/features/auth/LoginPage"));
const ChatbotPage = lazy(() => import("@/features/chat/ChatbotPage"));
const AccountsBackendPage = lazy(() => import("@/features/accounts/AccountsBackendPage"));
const LandingPage = lazy(() => import("@/features/landing/LandingPage").then((mod) => ({ default: mod.LandingPage })));
const UniversePage = lazy(() => import("@/features/universe/UniversePage").then((mod) => ({ default: mod.UniversePage })));
const CompanyPage = lazy(() => import("@/features/company/CompanyPage").then((mod) => ({ default: mod.CompanyPage })));

function LegacyHtmlRedirect() {
  const location = useLocation();
  if (location.pathname === "/galaxy.html") {
    return <Navigate to={{ pathname: "/universe", search: location.search }} replace />;
  }
  if (location.pathname === "/csl.html") {
    return <Navigate to={{ pathname: "/company", search: location.search }} replace />;
  }
  if (location.pathname === "/landing.html") {
    return <Navigate to={{ pathname: "/", search: location.search, hash: location.hash }} replace />;
  }
  return <Navigate to="/" replace />;
}

export function AppRouter() {
  return (
    <Suspense fallback={<main>Loading...</main>}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/universe"
          element={
            <RequireAuth>
              <UniversePage />
            </RequireAuth>
          }
        />
        <Route
          path="/company"
          element={
            <RequireAuth>
              <CompanyPage />
            </RequireAuth>
          }
        />
        <Route
          path="/chat"
          element={
            <RequireAuth>
              <ErrorBoundary fallbackTitle="Chat error">
                <ChatbotPage />
              </ErrorBoundary>
            </RequireAuth>
          }
        />
        <Route
          path="/accounts"
          element={
            <RequireAuth ownerOnly>
              <ErrorBoundary fallbackTitle="Accounts error">
                <AccountsBackendPage />
              </ErrorBoundary>
            </RequireAuth>
          }
        />
        <Route path="/galaxy.html" element={<LegacyHtmlRedirect />} />
        <Route path="/csl.html" element={<LegacyHtmlRedirect />} />
        <Route path="/landing.html" element={<LegacyHtmlRedirect />} />
      </Routes>
    </Suspense>
  );
}
